//
//
//
//
//
//
//

export default {
    name: "myinput",
  data(){
    return {
    }
  },
  props:{
      value:'',
    placeholder:'',
    width:Number,
    label:'',
    readonly:false
  },
  methods:{
      inputChange(e){
        // console.log(this.$refs.input.value);
        this.$emit('input',this.$refs.input.value)
      }
  },
}



// WEBPACK FOOTER //
// ./src/components/common/myinput.vue